export enum FieldType {
    Scope = 1,
    PhotoScope = 2,
    DocumentScope = 3,
    Section = 4,
    ListSection = 5,
    BlockSection = 6,
    BlockListSection = 7,
    TireSetSection = 8,
    AxleSection = 9,
    TireSection = 10,
    String = 11,
    Integer = 12,
    Date = 13,
    Reference = 14,
    Boolean = 15,
    Flag = 16,
    Float = 17,
    Time = 18,
    Document = 19,
    Currency = 20,
    Photo = 21,
    Participant = 22,
    Country = 23,
    ComponentPart = 24,
    Line = 25,
    SelectionList = 27,
    SelectedLookups = 28,
}
